/* BILMA — Reordena el menú móvil: mueve la imagen de portada (arriba)
   a justo antes del logo de BILMA (abajo del menú). Solo mueve nodos ya
   existentes; no crea nada. En escritorio el menú móvil está oculto, así
   que no tiene ningún efecto visible ahí. */
(function () {
  function reorderMobileMenuImage() {
    var portada = document.querySelector('[class*="header-menu-mobile-image-top-"]');
    var logo = document.querySelector('[class*="header-menu-mobile-image-bottom-"]');
    if (portada && logo && logo.parentNode && portada !== logo.previousElementSibling) {
      logo.parentNode.insertBefore(portada, logo);
    }
  }
  if (document.readyState !== 'loading') {
    reorderMobileMenuImage();
  } else {
    document.addEventListener('DOMContentLoaded', reorderMobileMenuImage);
  }
  // Reaplicar en el editor de temas si la sección se recarga
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', reorderMobileMenuImage);
  }
})();
